export default __webpack_public_path__ + "static/media/header_precadastro.3e41452a.png";